export function useEInvoiceApplicabilityChecker({ formData, formState } = {}) {
  const GST_ELIGIBILITY_TURNOVER_THRESHOLD = 50000000;

  const sellerInfo = computed(() => {
    return unref(formData)?.seller ?? null;
  });

  const minimumAggregateTurnover = computed(() => {
    const minimumTurnover =
      unref(sellerInfo)?.aggregate_turnover_range?.minimum;

    if (minimumTurnover === "" || minimumTurnover == null) {
      return null;
    }

    const parsedTurnover = Number(minimumTurnover);

    return Number.isFinite(parsedTurnover) ? parsedTurnover : null;
  });

  const isSellerGstRegistered = computed(() => {
    const gstin = unref(sellerInfo)?.gstin?.trim?.() || "";

    return unref(sellerInfo)?.is_gst_registered === true && gstin.length === 15;
  });

  const isTurnoverEligible = computed(() => {
    const turnover = unref(minimumAggregateTurnover);

    if (turnover == null) {
      return false;
    }

    return turnover >= GST_ELIGIBILITY_TURNOVER_THRESHOLD;
  });

  const isTotalTaxEligible = computed(() => {
    return Number(unref(formData)?.total_tax || 0) > 0;
  });

  const isEInvoiceApplicable = computed(() => {
    return (
      unref(isSellerGstRegistered) &&
      unref(isTurnoverEligible) &&
      unref(isTotalTaxEligible)
    );
  });

  const showAddEInvoiceApplicabilityMessage = computed(() => {
    return (
      !unref(formState).preview &&
      !unref(formState).view &&
      !unref(formState).edit &&
      unref(isEInvoiceApplicable)
    );
  });

  const showPreviewEInvoiceApplicabilityMessage = computed(() => {
    return unref(formState).preview && unref(isEInvoiceApplicable);
  });

  return {
    showAddEInvoiceApplicabilityMessage,
    showPreviewEInvoiceApplicabilityMessage,
    isEInvoiceApplicable,
    isSellerGstRegistered,
    minimumAggregateTurnover,
  };
}
